import { Pricing } from '@/app/domain/Pricing';
import { Setting } from '@/app/domain/Setting';
import { Company } from '@/app/domain/Company';
import { Contact } from '@/app/domain/Contact';
import { ConsumerProfile } from '@/app/domain/ConsumerProfile';
import { EmailNotificationsSettings } from '@/app/domain/EmailNotificationsSettings';
import { UserPermissions } from '../services/UserPermissionsService';
import { DeleteAccountConfirmationStatus, CustomerType, TenantLicense } from '../services/DeleteAccountService';

export interface ModuleState {
  isWizardFetching: boolean;
  isWizardAvailable: boolean;
  pricing: Pricing | null;
  isPricingFetching: boolean;
  setting: Setting | null;
  isSettingFetching: boolean;
  isProfileFetching: boolean;
  selfServiceMode: boolean;
  isSelfServiceModeFetching: boolean;
  company: Company;
  isCompanyFetching: boolean;
  isCompanyEditing: boolean;
  consumerProfile: ConsumerProfile;
  isConsumerProfileFetching: boolean;
  isConsumerProfileEditing: boolean;
  emailNotificationsSettings: EmailNotificationsSettings;
  isEmailNotificationsSettingsFetching: boolean;
  isEmailNotificationsSettingsEditing: boolean;
  contactList: Contact[];
  addedContactList: Contact[];
  notAddedContactList: Contact[];
  isContactListFetching: boolean;
  isTenantContactListFetching: boolean;
  tenantContactList: Contact[];
  isDirectPartnerFetching: boolean;
  isDirectPartner: boolean;
  isContactCreating: boolean;
  isContactEditing: boolean;
  isContactDeleting: boolean;
  isVerificationEmailSending: boolean;
  isTenantLicensesFetching: boolean;
  tenantLicenses: TenantLicense[];
  isTenantStorageUsageFetching: boolean;
  tenantStorageUsage: number;
  isDeleteAccountConfirmationStatusFetching: boolean;
  deleteAccountConfirmationStatus: keyof typeof DeleteAccountConfirmationStatus | '';
  customerType: keyof typeof CustomerType | '';
  userPermissions: UserPermissions
}

export function createState(userPermissions: UserPermissions): ModuleState {
  return {
    isWizardFetching: false,
    isWizardAvailable: false,
    pricing: null,
    isPricingFetching: false,
    setting: null,
    isSettingFetching: false,
    isProfileFetching: false,
    selfServiceMode: false,
    isSelfServiceModeFetching: false,
    company: {},
    isCompanyFetching: false,
    isCompanyEditing: false,
    consumerProfile: {},
    isConsumerProfileFetching: false,
    isConsumerProfileEditing: false,
    emailNotificationsSettings: {} as EmailNotificationsSettings,
    isEmailNotificationsSettingsFetching: false,
    isEmailNotificationsSettingsEditing: false,
    contactList: [],
    addedContactList: [],
    notAddedContactList: [],
    isContactListFetching: false,
    isTenantContactListFetching: false,
    tenantContactList: [],
    isDirectPartnerFetching: false,
    isDirectPartner: false,
    isContactCreating: false,
    isContactEditing: false,
    isContactDeleting: false,
    isVerificationEmailSending: false,
    isTenantLicensesFetching: false,
    tenantLicenses: [],
    isTenantStorageUsageFetching: false,
    tenantStorageUsage: 0,
    isDeleteAccountConfirmationStatusFetching: false,
    deleteAccountConfirmationStatus: '',
    customerType: '',
    userPermissions: userPermissions || []
  };
}
